module.exports = __webpack_public_path__ + "static/media/pay-by-2c2p.2ddc562f.png";